import React from 'react';
const NotFoundPage = () => (
    <div className="tc pa5 vh-75 flex content-center justify-center items-center">
        <h3>Seite nicht gefunden</h3>
    </div>
)

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js